import { useNotes } from "@hq/client-react";
import type { Note } from "@hq/contracts";
import { normalizeTags, tagCounts } from "@hq/core";

export type TagCount = { tag: string; count: number };

const NONE: readonly Note[] = [];

/** Every tag in use across notes with its usage count, most used first. */
export function useAllTags(): TagCount[] {
  const { data } = useNotes();
  return tagCounts(data ?? NONE);
}

/** One typed tag the way `normalizeTags` would store it; `""` when nothing is left. */
export function normalizeTag(text: string): string {
  return normalizeTags([text])[0] ?? "";
}
